export function Button({
  disabled,
  onClick,
  text,
}: {
  disabled?: boolean
  onClick: () => void
  text: string
}): React.ReactElement {
  const baseClass = 'px-12 py-3 block rounded bg-purple text-md text-white hover:bg-purple-dark'
  const disabledClass = 'disabled:opacity-75 disabled:cursor-not-allowed disabled:bg-purple'

  return (
    <div className="m-0">
      <button className={`${baseClass} ${disabledClass}`} disabled={disabled} onClick={onClick}>
        {text}
      </button>
    </div>
  )
}
